import { ReviewsRoutes } from './type'

const reviews = `${ReviewsRoutes.root}`

export const ReviewsPath = {
  root: reviews,
  create: `${reviews}/${ReviewsRoutes.create}`,
  view: `${reviews}/${ReviewsRoutes.view}`,
}
